import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
  standalone: false
})
export class ErrorPopupComponent {
   @Input() message: string = '';
   isVisible: boolean = false;
   remainingTime: number = 5; // Tempo restante em segundos
   private timeoutId: any;
   private intervalId: any;
 
   show(message: string) {
     console.log('Showing popup with message:', message);
     this.message = message;
     this.isVisible = true;
     this.remainingTime = 5; // Reinicia o tempo restante
     this.startAutoCloseTimer();
     this.startCountdown();
   }
 
   close() {
     this.isVisible = false;
     this.clearAutoCloseTimer();
     this.clearCountdown();
   }
 
   private startAutoCloseTimer() {
     this.clearAutoCloseTimer();
     this.timeoutId = setTimeout(() => {
       this.close();
     }, 5000); // 5 segundos
   }
 
   private clearAutoCloseTimer() {
     if (this.timeoutId) {
       clearTimeout(this.timeoutId);
       this.timeoutId = null;
     }
   }
 
   private startCountdown() {
     this.clearCountdown();
     this.intervalId = setInterval(() => {
       if (this.remainingTime > 0) {
         this.remainingTime--;
       }
     }, 1000); // Atualiza a cada segundo
   }
 
   private clearCountdown() {
     if (this.intervalId) {
       clearInterval(this.intervalId);
       this.intervalId = null;
     }
   }
}